import { createAPIGatewayUrl } from "../../../common/scripts/create_url";
import VueStore from "../../../store/VueStore";

export class RequestParamsMaker {
  public static makeDeleteMstSignallampComponentParams(signallampID: number) {
    return {
      method: "post",
      url: createAPIGatewayUrl("deleteMstSignallampComponentSetting"),
      data: {
        user_id: VueStore.state.userName,
        signallamp_id: signallampID,
      },
      headers: {
        Authorization: VueStore.state.token,
      },
    };
  }
}
